import api from '../api'

const GLOBE_EMAIL_PATTERN = /^[^\s@]+@(globe|gsupport)\.com\.ph$/

export const validateNewAccessEmail = async (
	email: string
): Promise<string | true> => {
	const trimmedEmail = email.trim()

	if (!trimmedEmail || !GLOBE_EMAIL_PATTERN.test(trimmedEmail)) {
		return true
	}

	const existingAccess = await api.accessManagement.getUserPermissions(trimmedEmail)
	if (existingAccess.body?.length > 0) {
		return 'This user already has access configured in SSP'
	}

	return true
}
